function ModalMembroAprovador() {
  const modalAprovador = $('#modal-aprovador');
  const divListaFluxos = modalAprovador.find('#lista-fluxos');
  const approvers = $('[data-aprovador]');
  const approversv2 = $('[data-aprovadorv2]');

  approvers.on('click', function (e) {
    const fluxos = JSON.parse(this.dataset.aprovador);

    let html = '';
    fluxos.forEach(function (fluxo) {
      html += '<li>' + fluxo + '</li>';
    });

    divListaFluxos.html(html);
    modalAprovador.modal('show');
  });

  approversv2.on('click', function (e) {
    const userId = this.dataset.aprovadorv2;
    $.ajax({
      url: route('app.settings.membros-de-equipe.validar-desativacao', userId),
      method: 'GET',
      async: false,
      complete: function (requestReturn) {
        const returnData = requestReturn.responseJSON;
        const fluxos = returnData.data;

        let html = '';
        fluxos.forEach(function (fluxo) {
          html += '<li>' + fluxo + '</li>';
        });

        divListaFluxos.html(html);
        modalAprovador.modal('show');
      }
    });
  })
}

module.exports = {
  init: ModalMembroAprovador,
  url: /^\/settings\/membros-de-equipe/
};

